const state = {
  complaints_list: undefined,
  selected_complaints: "",
  category_list: undefined,
  selected_category: "",
  sub_category_list: undefined,
  selected_sub_category: ""
};

// getters
const getters = {
  get_complaints_list: state => state.complaints_list,
  get_selected_complaints: state => state.selected_complaints,
  get_category_list: state => state.category_list,
  get_selected_category: state => state.selected_category,
  get_sub_category_list: state => state.sub_category_list,
  get_selected_sub_category: state => state.selected_sub_category,
};

// mutations
const mutations = {
  set_complaints_list(state, data) {
    state.complaints_list = data;
  },
  set_selected_complaints(state, data) {
    state.selected_complaints = data;
  },
  set_category_list(state, data) {
    state.category_list = data;
  },
  set_selected_category(state, data) {
    state.selected_category = data;
  },
  set_sub_category_list(state, data) {
    state.sub_category_list = data;
  },
  set_selected_sub_category(state, data) {
    state.selected_sub_category = data;
  },
};

// actions
const actions = {
  set_complaints_list({ commit }, data) {
    commit("set_complaints_list", data);
  },
  set_selected_complaints({ commit }, data) {
    commit("set_selected_complaints", data);
  },
  set_category_list({ commit }, data) {
    commit("set_category_list", data);
  },
  set_selected_category({ commit }, data) {
    commit("set_selected_category", data);
  },
  set_sub_category_list({ commit }, data) {
    commit("set_sub_category_list", data);
  },
  set_selected_sub_category({ commit }, data) {
    commit("set_selected_sub_category", data);
  }
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/home.js